import React from "react";

const ServiceRequestForm = ({
  currentStep,
  inputText,
  setInputText,
  onSendMessage,
  stepIndex,
  totalSteps,
  error,
  isSubmitting,
  onCancel
}) => {
  if (!currentStep || currentStep.type === "select") return null;

  return (
    <div className="bg-white rounded-2xl shadow-[0_4px_16px_rgba(0,0,0,0.05)] p-3 flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyPress={(e) => { if (e.key === "Enter") { e.preventDefault(); onSendMessage(); }}}
          disabled={isSubmitting}
          aria-label="Type your answer"
          placeholder={
            currentStep?.key === "mobileNumber" 
              ? "Enter 10-digit mobile number" 
              : currentStep?.key === "description"
              ? "Enter description..."
              : currentStep?.key === "attachmentName"
              ? "Enter attachment name..."
              : "Type your answer..."
          }
          className="flex-grow outline-none text-sm text-gray-900 placeholder:text-gray-500 bg-transparent border-b border-gray-300 pb-1"
        />
        <button
          onClick={onSendMessage}
          disabled={isSubmitting || inputText.trim() === ""}
          className={`px-3 py-1.5 text-xs rounded-full ${inputText.trim() !== "" ? "bg-[#1A1718] text-white" : "bg-gray-200 text-gray-500"}`}
        >
          Send
        </button>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-[10px] text-gray-500">Step {Math.min(stepIndex + 1, totalSteps)} of {totalSteps}</span>
        <div className="flex gap-2">
          {error && <span className="text-[10px] text-red-600">{error}</span>}
          <button
            onClick={onCancel}
            disabled={isSubmitting}
            className="text-[11px] text-gray-600 hover:text-black"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceRequestForm;

